import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Kundali() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        gender: "",
        dob: "",
        tob: "",
        place: ""
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Kundali Input:", form);
        // Call API / navigate to kundali page
        navigate("/kundali-result",{
            state:{
                name:form.name,
                gender:form.gender,
                dob:form.dob,
                tob:form.tob,
                place:form.place,
            }
        })
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Get Free Kundali</h1>
            <p style={styles.subtitle}>
                Enter your birth details to generate your Janma Kundali
            </p>

            <form style={styles.card} onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={form.name}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <select
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                    style={styles.input}
                    required
                >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                </select>

                <input
                    type="date"
                    name="dob"
                    value={form.dob}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <input
                    type="time"
                    name="tob"
                    value={form.tob}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <input
                    type="text"
                    name="place"
                    placeholder="Place of Birth"
                    value={form.place}
                    onChange={handleChange}
                    style={styles.input}
                    required
                />

                <button type="submit" style={styles.button}>
                    Generate Kundali
                </button>
            </form>
        </div>
    );
}



const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "40px",
    width:"100%"
  },
  title: {
    fontSize: "32px",
    color: "#7c2d12"
  },
  subtitle: {
    color: "#92400e",
    marginBottom: "20px"
  },
  card: {
    background: "#ffffff",
    padding: "25px",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "400px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  input: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "6px",
    border: "1px solid #d1d5db"
  },
  button: {
    marginTop: "10px",
    padding: "12px",
    background: "#b45309",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer"
  }
};